<template>
    <div>
        <app-header></app-header>
        <main id="page-main" class="with-tabs">
            <nav>
                <ul>
                    <li><router-link :to="{ name: 'crm-dashboard' }"><i class="icon icon-icon_home"></i></router-link></li>
                    <li v-if="$store.state.modules.indexOf('crm.person')>=0"><router-link :to="{ name: 'person' }"><i class="icon icon-icon_users"></i> Person</router-link></li>
                    <li v-if="$store.state.modules.indexOf('crm.company')>=0"><router-link :to="{ name: 'company' }"><i class="icon icon-icon_company"></i> Company</router-link></li>
                </ul>
            </nav>
            <router-view></router-view>
        </main>
    </div>
</template>
<script>

    export default {
        name: 'Company',
        data () {
            return {

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/crm/Index.vue